import React from 'react';

import { IconLock } from '@tabler/icons';

import { Container } from './styles';

const Private: React.FC = () => {
  return (
    <Container>
      <div>
        <IconLock size={100} color="#777" />
      </div>

      <h2>Conteúdo privado</h2>
      <p>
        O conteúdo que você está tentando acessar não está disponível
        publicamente.
      </p>
    </Container>
  );
};

export default Private;
